"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 事件监听&触发
 */
var type_1 = require("./type");
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        /**
         * 事件处理器
         */
        this.eventHandlers = new Map();
    }
    /**
     * 注册自定义事件
     * @param event
     * @param handler
     */
    EventEmitter.prototype.on = function (event, handler) {
        if (!event || !(0, type_1.isFunction)(handler)) {
            return;
        }
        var handlers = this.eventHandlers.get(event);
        if (!handlers) {
            handlers = new Set();
            this.eventHandlers.set(event, handlers);
        }
        // 注册回调事件
        handlers.add(handler);
    };
    /**
     * 注销自定义事件
     * @param event
     * @param handler
     */
    EventEmitter.prototype.off = function (event, handler) {
        if (!event) {
            return;
        }
        // 不传handler则请求该event的回调
        if (!(0, type_1.isFunction)(handler)) {
            this.eventHandlers.set(event, new Set());
            return;
        }
        var handlers = this.eventHandlers.get(event);
        if (handlers) {
            handlers.delete(handler);
        }
    };
    /**
     * 派发自定义事件
     * @param event 事件名
     * @param payload 事件参数
     */
    EventEmitter.prototype.emit = function (event, payload) {
        if (!event)
            return;
        // 发布消息给当前所有订阅者
        var handlers = this.eventHandlers.get(event);
        if (handlers) {
            handlers.forEach(function (handler) {
                try {
                    handler(payload);
                }
                catch (error) {
                    console.error('eventBus事件回调执行错误：', event, error);
                }
            });
        }
    };
    return EventEmitter;
}());
exports.default = EventEmitter;
